
export default function negitiveStringDisply(obj,hasDollor) {
    
  return obj && Number(obj.replace(/,/g,""))<0?"(" +(hasDollor?"$ ":"")  +obj.replace("-","")+")":(hasDollor?"$ ":"")+obj;

}
 